import React, { useState } from "react";
import allImageOfClient from "../../assets/fake-data/clientImages";
import { Link } from "react-router-dom";

const LogoSection = () => {
  const [dataBlock] = useState({
    description:
      "  Velit sed ullamcorper morbi tincidunt ornare. Ipsum consequat nisl vel pretium. Odio ut sem nulla pharetra diam sit. Amet est placerat in egestas erat imperdiet sed euismod.",
  });
  return (
    <>
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-[30px]">
            {allImageOfClient.slice(0, 4).map((x) => {
              return (
                <div key={x.id} className="lg:p-9 p-5">
                  <img src={x.image} alt="logo-img" className="mx-auto" />
                </div>
              );
            })}
          </div>
          <div className="bg-dark/[0.04] h-[1px] w-full inline-block"></div>
          <div className="grid grid-cols-1 mt-12">
            <div className="text-center">
              <p className="text-muted max-w-[600px] mx-auto leading-[1.6]">
                {dataBlock.description}
              </p>
              <div className="mt-10">
                <Link to="#" className="btn btn-custom rounded-full">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogoSection;
